<template>
  <div>
    <div class="userinfo">
      <div class="info_left">
        <div class="info_left_img">
          <img src="../../image/userimg.png" />
        </div>
      </div>
      <div class="information">
        <div class="infophone">{{ formInline.phone }}</div>
        <div class="infotheory">
          <div style="width: 160px;">
            会员状态:
            <span style="color:rgb(246,180,58)"> {{ formInline.status }}</span>
          </div>

          <div style="width: 260px;">
            开通时间:
            <span style="color:rgb(49,49,49)"> {{ formInline.timeOpen }}</span>
          </div>
          <div style="width: 178px;">
            到期期间:
            <span style="color:rgb(49,49,49)">
              {{ formInline.timeExpire }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="title">
      <div>基本信息</div>
      <div>
        <el-button class="info_right" @click="editInformation">编辑</el-button>
      </div>
    </div>
    <div class="user_message">
      <div class="message">
        <div class="message_left">昵称： {{ formInline.name }}</div>
        <div class="message_right">
          性别：{{ formInline.sex == 1 ? "男" : "女" }}
        </div>
      </div>
      <div class="message">
        <div class="message_left">年龄: {{ formInline.age }}岁</div>
        <div class="message_right">职业：{{ formInline.occupation }}</div>
      </div>

      <div class="message">
        <div class="message_left">常驻城市: {{ formInline.city }}</div>
        <!-- <div class="message_right">常住城市：武汉</div> -->
      </div>
    </div>
    <div class="title">订单记录</div>
    <!-- 表单数据 -->

    <el-table
      ref="multipleTable"
      :data="tenanttableData"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column prop="timeCreate" label="操作时间"> </el-table-column>
      <el-table-column prop="operator" label="操作人"> </el-table-column>
      <el-table-column prop="remark" label="操作信息"> </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="paging">
      <div class="block">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 15, 25, 50]"
          :page-size="8"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="个人档案"
      class="title_center"
      :visible.sync="userInfoVisible"
      width="600px"
      :show-close="false"
    >
      <el-form :model="userInfo" :rules="rules" :hide-required-asterisk="true">
        <el-form-item label="昵称：" label-width="85px" prop="name">
          <el-input v-model="userInfo.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="性别：" label-width="85px">
          <el-radio v-model="userInfo.sex" label="1">男</el-radio>
          <el-radio v-model="userInfo.sex" label="0">女</el-radio>
        </el-form-item>

        <el-form-item label="年龄：" label-width="85px" prop="age">
          <el-input v-model="userInfo.age" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="职业：" label-width="85px" prop="occupation">
          <el-input v-model="userInfo.occupation" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="常驻城市：" label-width="85px" prop="city">
          <el-input v-model="userInfo.city" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" class="cancel">取 消</el-button>
        <el-button type="primary" @click="userInfoBtn" class="success_Btn"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 重置密码 -->
  </div>
</template>

<script>
import {
  getlistVip,
  getupdateVipInfo,
  getlistVipInfoChange
} from "../../api/index";
import premission from "../../utils/permission";
export default {
  mixins: [premission],
  data() {
    return {
      dynamicTagsOne: "",
      allotVisible: false,
      resetVisible: false,
      userInfoVisible: false,
      dialogImageUrl: "",
      dialogVisible_img: false,
      disabled: false,

      userInfo: {
        age: "",
        sex: "1",
        city: "",
        phone: "",
        occupation: "",
        operator: "",
        name: ""
      },
      rules: {
        age: [
          { required: true, message: "请填写正确的年龄", trigger: "blur" },
          {
            pattern: "[0-9]",
            message: "请填写正确的年龄",
            trigger: "blur"
          }
        ]
      },
      pageNum: 1,
      pageSize: 5,
      total: 0,
      currentPage: 1,
      tenanttableData: [],
      tableData: [],
      formInline: {
        age: "",
        sex: "",
        name: "",
        city: "",
        phone: "",
        occupation: "",
        timetwo: "",
        status: "",
        timeStart: "",
        timeEnd: "",
        timeExpireStart: "",
        timeExpireEnd: ""
      },
      statusbarlist: {
        status: [
          { type: 0, name: "会员" },
          { type: 1, name: "已过期" }
        ]
      }
    };
  },
  computed: {
    headers() {
      return {
        Authorization: "Bearer " + this.$store.state.user // 直接从本地获取token就行
      };
    }
  },
  created() {
    if (this.$route.params.phone) {
      sessionStorage.setItem("themmephone", this.$route.params.phone); //将params中的值存在本地，并且当他为空时不刷新
    }
    this.themmephone();
    this.themenviplist();
  },
  methods: {
    // 数据返回数字转文字页面渲染
    tranfromType(info) {
      ["status"].forEach(key => {
        info[key] = this.statusbarlist[key]?.find(
          i => i.type === Number(info[key])
        )?.name;
      });
    },

    // 头部数据
    themmephone() {
      this.formInline.phone = sessionStorage.getItem("themmephone");
      let data = {
        phone: this.formInline.phone
      };
      getlistVip(data).then(res => {
        let data = res.data.data.list;
        data.forEach(info => {
          this.tranfromType(info);
        });
        this.formInline = data[0];
        console.log(this.formInline);
      });
    },
    // 基本信息和记录数据
    themenviplist() {
      let data = {
        phone: this.formInline.phone,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      getlistVipInfoChange(data).then(res => {
        this.total = res.data.data.total;
        this.tenanttableData = res.data.data.list;
      });
    },
    // 编辑信息
    editInformation() {
      console.log(this.formInline.sex);
      this.userInfoVisible = true;
      this.userInfo.age = this.formInline.age;
      this.userInfo.name = this.formInline.name;
      this.userInfo.sex = this.formInline.sex.toString();
      this.userInfo.city = this.formInline.city;
      this.userInfo.occupation = this.formInline.occupation;
    },
    handler() {},
    // 编辑确认
    userInfoBtn() {
      this.userInfo.phone = sessionStorage.getItem("themmephone");
      let data = this.userInfo;
      console.log(data);
      getupdateVipInfo(data).then(res => {
        console.log(res);
        this.themenviplist();
        this.themmephone();
        this.userInfo = {
            age: "",
            sex: "1",
            city: "",
            phone: "",
            occupation: "",
            operator: "",
            name: ""
        };
        this.userInfoVisible = false;
      });
    },
    // 取消
    cancel() {
      this.userInfo = {};
      this.userInfoVisible = false;
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.themenviplist();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.themenviplist();
    },
    handleSelectionChange() {}
  }
};
</script>
<style lang="less" scoped>
.userinfo {
  height: 180px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: row;
  .info_left {
    width: 226px;
    .info_left_img {
      overflow: hidden;
      border-radius: 50%;
      width: 150px;
      height: 150px;
      img {
        height: 100%;
        width: 100%;
      }
    }
  }
  .information {
    width: 900px;
    height: 100%;
    .infophone {
      font-size: 28px;
      margin-top: 10px;
    }
    .infotheory {
      width: 706px;
      font-size: 14px;
      margin-top: 43px;
      font-weight: 550;
      color: rgb(196, 196, 196);
      letter-spacing: 2px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
}
.title {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 85%;
  height: 26px;
  line-height: 26px;
  font-size: 20px;
  text-indent: 15px;
  .info_right {
    background-color: rgb(246, 180, 58);
    color: #f2f2f2;
    font-weight: 550;
    letter-spacing: 2px;
  }
}
.title::before {
  position: absolute;
  left: 0px;
  top: -3px;
  height: 36px;
  width: 6px;
  content: "";
  border-radius: 3px;
  background-color: #f6b439;
}
/deep/.el-table__header-wrapper {
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  height: 50px;
  border-radius: 0px;
  .el-table__header {
    height: 50px;
    tr {
      height: 50px;
      th {
        background-color: #f2f2f2;
        text-align: center;
      }
    }
  }
}
/deep/ .el-table__row td {
  text-align: center;
  height: 60px;
  padding: 4px 0;
}
.user_message {
  margin-top: 25px;
  padding: 20px 15px;
  margin-bottom: 60px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  .message {
    position: relative;
    height: 45px;
    font-size: 16px;
    .message_left {
      position: absolute;
      top: 0px;
      left: 0px;
      line-height: 45px;
    }
    .message_right {
      position: absolute;
      top: 0px;
      left: 548px;
      line-height: 45px;
    }
  }
}

.el-table {
  margin-top: 10px;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #f6b439;
}
.paging {
  margin-top: 40px;
  margin-left: 610px;
}
.QuickMark {
  float: left;
  margin-right: 12px;
  width: 80px;
  height: 80px;
}
/deep/.image-slot {
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.communication_box {
  width: 1600px;
  // height: 524px;
  border: 1px solid #e1e1e1;
  border-bottom: none;
  box-sizing: border-box;
  .communication_list {
    padding: 16px 13px;
    border-bottom: 1px solid #e1e1e1;
    .communication_list_top {
      font-size: 16px;
      color: #171a1e;
      margin-bottom: 8px;
    }
    .communication_list_center {
      height: 21px;
      font-size: 16px;
      color: #999;
      margin-bottom: 10px;
    }
  }
}

.communication_list_bottom {
  height: 80px;
}

.checkBox {
  cursor: pointer;
  color: #666666;
  line-height: 20px;
  text-align: center;
  width: 1600px;
  height: 20px;
  font-size: 12px;
  background-color: #f2f2f2;
  .el-icon-arrow-down {
    font-size: 14px;
  }
}
/deep/.el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 80px;
}

/deep/.el-upload-list--picture-card .el-upload-list__item {
  height: 80px;
  width: 80px;
}
.cancel {
  width: 72px;
  height: 36px;
  background-color: #f2f2f2;
  border: 1px solid #e1e1e1;
  box-sizing: border-box;
  border-radius: 4px;
}
.success_Btn {
  margin-left: 24px;
  width: 72px;
  height: 36px;
  background-color: #f6b439;
  border: 1px solid #f6b439;
  box-sizing: border-box;
  border-radius: 4px;
}
/deep/.el-radio__label {
  font-size: 16px;
}
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #f6b439;
}
/deep/.el-radio__inner {
  width: 24px;
  height: 24px;
}
/deep/.el-radio__inner::after {
  width: 10px;
  height: 10px;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #f6b439;
  background: #f6b439;
  width: 24px;
  height: 24px;
}
.title_center {
  /deep/.el-dialog__header {
    text-align: center;
  }
}
.resetPassText {
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.333333px;
  text-align: center;
  color: #999999;
}
.AddLabel {
  width: 540px;
  min-height: 42px;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  margin-bottom: 24px;
  .el-tag.el-tag--warning {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
  }
}
/deep/.el-dialog__body {
  padding: 24px 30px;
}
/deep/.el-dialog__header {
  padding: 40px 30px 0;
}
/deep/.el-dialog__footer {
  padding: 10px 30px 20px;
}
.select_list_tree {
  overflow: hidden;
  width: 540px;
  padding: 20px 30px;
  border: 1px solid #e1e1e1;
  .treeList {
    float: left;
    width: 280px;
  }
  .select_list_checkBox {
    padding: 0 30px 0 30px;
    float: right;
    width: 198px;
    border-left: 1px solid #e1e1e1;
    .select_list_checkBox_list {
      width: 100%;
      height: 32px;
    }
  }
}
</style>
